import React from 'react';

const Imprint = () => {
     const styles = {
    container: {
      fontFamily: '"Geist", sans-serif',
      padding: '20px',
      lineHeight: 1.6,
      color: '#111',
    },
    heading1: {
      fontSize: '22px',
      fontWeight: 'bold',
      marginBottom: '16px',
    },
    heading3: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginTop: '24px',
      marginBottom: '8px',
    },
    paragraph: {
      fontSize: '14px',
      marginBottom: '12px',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading1}>Imprint</h1>

      <h3 style={styles.heading3}>Angaben gemäß § 5 TMG</h3>
      <p style={styles.paragraph}>
        Jim-Linus Valentin Ahrend<br />
        Jim-Linus Valentin Ahrend Software Productions<br />
        64380 Roßdorf, Germany
      </p>

      <h3 style={styles.heading3}>Kontakt</h3>
      <p style={styles.paragraph}>E-Mail: valentin@ahrend.de</p>

      <h3 style={styles.heading3}>Haftung für Inhalte</h3>
      <p style={styles.paragraph}>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die
        Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch
        keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG
        für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
        verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch
        nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
        überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
        Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
        Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
        unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>

      <h3 style={styles.heading3}>Haftung für Links</h3>
      <p style={styles.paragraph}>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte
        wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch
        keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
        jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
        Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
        überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
        erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
        jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
        entfernen.
      </p>

      <h3 style={styles.heading3}>Urheberrecht</h3>
      <p style={styles.paragraph}>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
        Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors
        bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
        privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
        dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
        Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
        gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
        aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend
        entfernen.
      </p>
    </div>
  );
};

export default Imprint;